import {LIMS_SAMPLING_POINTS_QUERY_KEY, limsSamplingPoints} from './getLimsSamplingPoints'
import {SAMPLING_POINTS_QUERY_KEY, samplingPoints} from './getSamplingPoints'
import {SAMPLING_POINTS_COUNTS_QUERY_KEY, samplingPointsCounts} from './getSamplingPointsCounts'
import {
  GET_SAMPLING_POINTS_PINNED_SECTION_KEY,
  getSamplingPointsPinnedSection
} from './getSamplingPointsPinnedSection'
import {SAMPLING_POINT_TYPES_QUERY_KEY, samplingPointTypes} from './getSamplingPointTypes'

export const samplingPointsQueries = {
  [SAMPLING_POINTS_QUERY_KEY]: samplingPoints,
  [LIMS_SAMPLING_POINTS_QUERY_KEY]: limsSamplingPoints,
  [SAMPLING_POINT_TYPES_QUERY_KEY]: samplingPointTypes,
  [SAMPLING_POINTS_COUNTS_QUERY_KEY]: samplingPointsCounts,
  [GET_SAMPLING_POINTS_PINNED_SECTION_KEY]: getSamplingPointsPinnedSection
}
